export const encryptWithPublicKey = async (params: { text: string, publicKey: string }) => {
   // Import RSA public key
   const key = await crypto.subtle.importKey(
      'spki',
      pemToArrayBuffer(params.publicKey),
      { name: 'RSA-OAEP', hash: 'SHA-256' },
      false,
      ['encrypt']
   );

   // Encrypt password
   const encrypted = await crypto.subtle.encrypt(
      'RSA-OAEP',
      key,
      new TextEncoder().encode(params.text)
   );

   return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

const pemToArrayBuffer = (pem: string) => {
   const b64 = pem.replace(/-----.*-----|\r|\n/g, '');
   const binary = atob(b64);
   const bytes = new Uint8Array(binary.length);
   for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
   }
   return bytes.buffer;
}

